import React, { useState, useRef } from 'react';

interface SecretKeyFieldProps {
  keyString: string;
  id?: string;
}

export const SecretKeyField = ({ keyString, id }: SecretKeyFieldProps) => {
  //Key visibility toggling
  const secretEntities = Array.from({ length: 14 }, (_, index) => (
    <span key={index}> &#10034;</span>
  ));

  const keyRef = useRef<HTMLInputElement>(null);
  const [showKey, setShowKey] = useState(false);
  const toggleKey = () => {
    keyRef.current?.focus();
    setShowKey(!showKey);
  };

  // Copy key
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(keyString)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="flex items-center gap-2 w-full max-w-[200px] sm:max-w-sm p-2.5 rounded-md border dark:text-blue-100 dark:bg-blue-900 dark:border-grey-600 bg-grey-100 border-grey-500">
      <div id={id} ref={keyRef} className="flex-1 min-w-0 overflow-hidden">
        {showKey ? (
          <span className="block py-1 text-base truncate">{keyString}</span>
        ) : (
          <span className="flex gap-1 items-center h-8 text-base">{secretEntities}</span>
        )}
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <button
          className="material-symbols-outlined dark:text-blue-200"
          onClick={toggleKey}
          type="button"
        >
          {showKey ? 'visibility_off' : 'visibility'}
        </button>
        <div className="h-6 w-[1px] bg-grey-600 dark:bg-grey-600"></div>
        <button
          className="material-symbols-outlined dark:text-blue-200"
          onClick={handleCopyClick}
          type="button"
        >
          {isCopied ? 'check' : 'content_copy'}
        </button>
      </div>
    </div>
  );
};
